export default __webpack_public_path__ + "static/media/mediaPictureBlank.891a65b3.png";